import { ModuleConstant } from '@/common/util/module-constant';
import { eventHub } from '@/main';
import httpClient from './http-client';

const list = (filter) => {
	const params = {
		query: filter,
	};

	return httpClient.invoke('user', 'list', params);
};

const get = (userId) => {
	const params = {
		query: {
			userId: userId,
		},
	};

	return httpClient.invoke('user', 'get', params);
};

const add = (filter, data) => {
	const params = {
		query: filter,
		data: data,
	};

	return httpClient.invoke('user', 'add', params);
};

const update = (filter, userId, data) => {
	const params = {
		query: filter,
		data: data,
	};

	params.query.userId = userId;

	params.data.op = 'update';

	return httpClient.invoke('user', 'update', params);
};

const remove = (userId) => {
	const params = {
		query: {
			userId: userId,
		},
	};

	return httpClient.invoke('user', 'remove', params);
};

const login = (data) => {
	const params = {
		data: data,
	};

	return httpClient.invoke('user', 'login', params).then((response) => {
		if (response.data && response.data.token && response.data.token.access) {
			let parts = response.data.token.access.split('.');
			let content = JSON.parse(decodeURIComponent(escape(atob(parts[1]))));

			const writeRoles = ['Cliente - Admin', 'Backoffice A4 - Admin'];
			let clientRoles = [];
			let permissionLevel;

			// TODO: alterar na próxima sprint de remodalegem de autorização...
			// espero que não fique aqui pra sempre...
			if (content.roles.length) {
				permissionLevel =
					writeRoles.indexOf(content.roles[0].name) >= 0 ? 'full' : 'read';
			}

			if (!content.isAdmin) {
				if (permissionLevel === 'read') {
					clientRoles = ['Cliente - Somente leitura'];
				} else {
					clientRoles = ['Cliente - Admin', 'Cliente - Somente leitura'];
				}
			}

			content.appModules = JSON.parse(content.appModules);

			setCurrentUser({
				id: content.id,
				name: content.name,
				isAdmin: content.isAdmin,
				email: content.email,
				language: content.language,
				clientId: content.client,
				permissionLevel: permissionLevel,
				clientRoles: clientRoles,
				appModules: content.appModules,
			});
		}

		return response;
	});
};

const logout = () => {
	clearCurrentUser();
	sessionStorage.clear();
};

const setCurrentUser = (user) => {
	eventHub.$emit('LOGGED_USER', user);
	sessionStorage.setItem('CURRENT_USER', JSON.stringify(user));
};

const getCurrentUser = () => {
	const json = sessionStorage.getItem('CURRENT_USER');
	let user;

	if (json) {
		user = JSON.parse(json);
	}

	return user;
};

const getUserLocale = () => {
	return getCurrentUser()?.language;
};

const clearCurrentUser = () => {
	sessionStorage.removeItem('CURRENT_USER');
};

const requestPasswordReset = (email) => {
	const params = {
		data: {
			op: 'recover-password',
			username: email,
		},
	};

	return httpClient.invoke('user', 'requestPasswordReset', params);
};

const resetPassword = (token, password) => {
	const params = {
		data: {
			op: 'redefine',
			recover: token,
			password: password,
		},
	};

	return httpClient.invoke('user', 'resetPassword', params);
};

const rememberAccount = (cpf) => {
	const params = {
		data: {
			op: 'recover-username',
			cpf: cpf,
		},
	};

	return httpClient.invoke('user', 'rememberAccount', params);
};

const getAppModule = () => {
	return JSON.parse(sessionStorage.getItem('SELECTED_MODULE') || 0);
};

const isSmartSafetyModule = () => {
	return getAppModule() == ModuleConstant.Module.SmartSafety;
};

const isVisionModule = () => {
	return getAppModule() == ModuleConstant.Module.Vision;
};

const setAppModule = (moduleId) => {
	sessionStorage.setItem('SELECTED_MODULE', JSON.parse(moduleId));
	eventHub.$emit('MODULE_SELECTED', moduleId);
};

const canAccessModule = (module, modelId) => {
	return module.some((module) => module.meta.Module == modelId);
};

export default {
	list,
	get,
	add,
	update,
	remove,

	login,
	logout,
	setCurrentUser,
	getCurrentUser,
	getUserLocale,
	clearCurrentUser,
	requestPasswordReset,
	resetPassword,
	rememberAccount,

	getAppModule,
	setAppModule,

	isSmartSafetyModule,
	isVisionModule,
	canAccessModule,
};
